import { AnimatePresence, motion } from "framer-motion"
import * as React from "react"
import styled from "styled-components"
import { Link } from "react-router-dom"
import { theme } from "../../../components/theme"
import NavigationTextButton from "../../atoms/buttons/NavigationTextButton"
import { HorizontalSpacer } from "../../atoms/spacers"
import Line from "../../atoms/Line"
import MobileNavSubMenu from "./MobileNavSubMenu"
import { CONTACT, NavItem, navItemsMobile } from "../../../utils/nav-helpers"
import SmallButton from "../../atoms/buttons/SmallButton"

interface Props {
  open: boolean
  userLoggedIn: boolean
  cartNumber?: number
  onClose: () => void
}

const ModalContainer = styled.div`
  width: 90vw;
  height: 100vh;
  position: absolute;
  top: 12px;
  right: -10px;
  z-index: 100;
`

const ModalContent = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${(props) => props.theme.colors.greyDarker};
  opacity: 90%;
  padding: 2rem;
  padding-bottom: 5rem;
  overflow-y: scroll;
`

const NavLink = styled(Link)``

const MobileNavBar: React.FC<Props> = ({ open, userLoggedIn, cartNumber, onClose }) => {
  const { afterDivider, beforeDivider } = React.useMemo(() => navItemsMobile(userLoggedIn), [userLoggedIn])

  const renderNavItems = (items: NavItem[]) =>
    items
      .map(
        (item) =>
          !item.hidden &&
          ("subMenu" in item ? (
            <MobileNavSubMenu key={item.title} title={item.title} active={location?.pathname?.includes(item.path)}>
              <HorizontalSpacer spacing={4} />
              {intersperseSpacers(renderNavItems(item.subMenu))}
            </MobileNavSubMenu>
          ) : (
            <NavLink as={item.anchor ? "a" : Link} href={item.path} to={item.path} key={item.title} onClick={onClose}>
              <NavigationTextButton
                title={item.title}
                color={theme.colors.white}
                active={location?.pathname == item.path}
                icon={item.icon && <item.icon fill={theme.colors.white} cartNumber={cartNumber} />}
              />
            </NavLink>
          )),
      )
      .filter((item): item is JSX.Element => item !== false)

  const intersperseSpacers = (items: JSX.Element[]) =>
    items.flatMap((item, i) => [<HorizontalSpacer key={i} spacing={3} />, item]).slice(1)

  return (
    <div style={{ zIndex: 100 }}>
      <AnimatePresence>
        {open && (
          <motion.div
            style={{ position: "relative" }}
            key="modal"
            initial={{ opacity: 0, x: "100%", zIndex: 10 }}
            animate={{ opacity: 100, x: "10%", zIndex: 30 }}
            exit={{ opacity: 0, x: "100%" }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
          >
            <ModalContainer>
              <ModalContent>
                <Link to={CONTACT.path}>
                  <SmallButton title="Request demo" onClick={onClose} />
                </Link>
                <HorizontalSpacer spacing={2} />
                {intersperseSpacers(renderNavItems(beforeDivider))}
                <HorizontalSpacer spacing={2} />
                <Line white />
                <HorizontalSpacer spacing={2} />
                {intersperseSpacers(renderNavItems(afterDivider))}
              </ModalContent>
            </ModalContainer>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}

export default MobileNavBar
